(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-search-panel]');
    if (!dialog || !window.theme) return;
    const { Drawer, money } = window.theme;
    const drawer = new Drawer(dialog);
    const input = dialog.querySelector('[data-search-input]');
    const results = dialog.querySelector('[data-search-results]');
    const texts = results.dataset;
    const hint = results.querySelector('[data-search-hint]');
    const templates = {
      product: dialog.querySelector('[data-search-template="product"]').content,
      link: dialog.querySelector('[data-search-template="link"]').content,
    };
    let controller = null;
    let timer = null;

    document.querySelectorAll('[data-search-open]').forEach((button) => {
      button.addEventListener('click', () => {
        drawer.open(button);
        button.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => input.focus());
      });
    });
    dialog.addEventListener('drawer:close', () => {
      document.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });

    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    const linkList = (items) => {
      const list = el('ul', 'predictive__links');
      list.setAttribute('role', 'list');
      for (const item of items) {
        const node = templates.link.cloneNode(true);
        const a = node.querySelector('a');
        a.href = item.url;
        a.textContent = item.title;
        list.append(node);
      }
      return list;
    };

    const render = (terms, { products, collections, pages }) => {
      results.replaceChildren();
      if (!products.length && !collections.length && !pages.length) {
        results.append(el('p', 'muted', texts.textNoResults.replace('%s', terms)));
        return;
      }
      const wrap = el('div', 'predictive');
      if (collections.length || pages.length) {
        const aside = el('div', 'predictive__aside');
        if (collections.length) aside.append(el('p', 'label', texts.textCollections), linkList(collections));
        if (pages.length) aside.append(el('p', 'label', texts.textPages), linkList(pages));
        wrap.append(aside);
      }
      if (products.length) {
        const block = el('div', 'predictive__products');
        block.append(el('p', 'label', texts.textProducts));
        const grid = el('ul', 'predictive__grid');
        grid.setAttribute('role', 'list');
        for (const product of products) {
          const node = templates.product.cloneNode(true);
          node.querySelector('a').href = product.url;
          const img = node.querySelector('img');
          if (product.featured_image?.url) {
            img.src = product.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2');
            img.alt = product.featured_image.alt || '';
          } else {
            img.remove();
          }
          // Vendeur = nom de la boutique : redondant, on ne l'affiche pas (comme sur les cartes).
          const vendor = product.vendor && product.vendor !== dialog.dataset.shopName ? product.vendor : '';
          node.querySelector('[data-field="vendor"]').textContent = vendor;
          node.querySelector('[data-field="title"]').textContent = product.title;
          // L'API JSON renvoie le prix en unités (« 89.00 »), money() attend des centimes.
          node.querySelector('[data-field="price"]').textContent = money(Math.round(Number(product.price) * 100));
          grid.append(node);
        }
        const all = el('a', 'link predictive__all', texts.textSeeAll.replace('%s', terms));
        all.href = `${texts.searchUrl}?q=${encodeURIComponent(terms)}&type=product`;
        block.append(grid, all);
        wrap.append(block);
      }
      results.append(wrap);
    };

    const suggest = async (terms) => {
      controller?.abort();
      if (terms.length < 2) {
        results.replaceChildren(hint);
        return;
      }
      controller = new AbortController();
      try {
        const url = `${window.Shopify?.routes?.root ?? '/'}search/suggest.json?q=${encodeURIComponent(terms)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title`;
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`suggest.json : ${response.status}`);
        const json = await response.json();
        render(terms, json.resources.results);
      } catch (error) {
        if (error.name !== 'AbortError') results.replaceChildren(hint);
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => suggest(input.value.trim()), 250);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-hours"] && !Shopify.designMode) return;
  try {
    (() => {
    const toMinutes = (hhmm) => {
      const [h, m] = hhmm.trim().split(':').map(Number);
      return h * 60 + (m || 0);
    };
    // getDay() : 0 = dimanche ; nos lignes vont de 0 = lundi à 6 = dimanche.
    const today = (new Date().getDay() + 6) % 7;
    const now = new Date();
    const minutes = now.getHours() * 60 + now.getMinutes();

    document.querySelectorAll('[data-store-hours]').forEach((root) => {
      const row = root.querySelector(`[data-day="${today}"]`);
      const line = root.querySelector('[data-store-today]');
      if (!row || !line) return;
      row.classList.add('store-hours__row--today');
      const ranges = (row.dataset.hours || '')
        .split(',')
        .map((r) => r.trim())
        .filter(Boolean)
        .map((r) => r.split('-').map((s) => s.trim()));
      let message = root.dataset.textClosedToday;
      let closed = true;
      for (const [open, close] of ranges) {
        if (minutes >= toMinutes(open) && minutes < toMinutes(close)) {
          message = root.dataset.textOpenUntil.replace('%s', close);
          closed = false;
          break;
        }
        if (minutes < toMinutes(open)) {
          message = root.dataset.textOpensAt.replace('%s', open);
          break;
        }
      }
      line.textContent = message;
      line.classList.toggle('store-hours__today--closed', closed);
      line.hidden = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-map"] && !Shopify.designMode) return;
  try {
    (() => {
    const maps = document.querySelectorAll('[data-store-map]');
    if (!maps.length) return;

    // Version épinglée : une montée de version se teste (rendu, attributions, gestes) avant d'être changée ici.
    const MAPLIBRE = 'https://cdn.jsdelivr.net/npm/maplibre-gl@4.7.1/dist/maplibre-gl';
    const STYLE = 'https://tiles.openfreemap.org/styles/positron';
    let loading = null;

    const loadLibrary = () => {
      if (window.maplibregl) return Promise.resolve(window.maplibregl);
      if (loading) return loading;
      loading = new Promise((resolve, reject) => {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = `${MAPLIBRE}.css`;
        document.head.append(css);
        const script = document.createElement('script');
        script.src = `${MAPLIBRE}.js`;
        script.async = true;
        script.onload = () => resolve(window.maplibregl);
        script.onerror = reject;
        document.head.append(script);
      });
      return loading;
    };

    const render = async (container) => {
      let markers;
      try {
        markers = JSON.parse(container.dataset.markers);
      } catch {
        return;
      }
      if (!markers.length) return;
      let maplibregl;
      try {
        maplibregl = await loadLibrary();
      } catch {
        return; // le lien de repli reste
      }
      const map = new maplibregl.Map({
        container,
        style: STYLE,
        center: [markers[0].lng, markers[0].lat],
        zoom: 15.5,
        attributionControl: { compact: true },
        cooperativeGestures: true,
        scrollZoom: false,
      });
      map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
      const bounds = new maplibregl.LngLatBounds();
      for (const store of markers) {
        const el = document.createElement('button');
        el.type = 'button';
        el.className = 'store-map__marker';
        el.setAttribute('aria-label', store.name);
        const card = document.createElement('div');
        const name = Object.assign(document.createElement('p'), { className: 'store-map__popup-name', textContent: store.name });
        const address = Object.assign(document.createElement('p'), { textContent: store.address });
        card.append(name, address);
        const popup = new maplibregl.Popup({ offset: 20, closeButton: false }).setDOMContent(card);
        new maplibregl.Marker({ element: el }).setLngLat([store.lng, store.lat]).setPopup(popup).addTo(map);
        bounds.extend([store.lng, store.lat]);
      }
      if (markers.length > 1) map.fitBounds(bounds, { padding: 64, maxZoom: 14, duration: 0 });
      map.once('load', () => container.classList.add('store-map--ready'));
    };

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          render(entry.target);
        }
      },
      { rootMargin: '300px 0px' },
    );
    maps.forEach((map) => observer.observe(map));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wordmark"] && !Shopify.designMode) return;
  try {
    (() => {
    const nodes = document.querySelectorAll('[data-wordmark]');
    if (!nodes.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const VERT = `
      attribute vec2 aPos;
      varying vec2 vUv;
      void main() {
        vUv = aPos * 0.5 + 0.5;
        gl_Position = vec4(aPos, 0.0, 1.0);
      }`;

    // Tout est en pixels de rendu (uRes) pour que le grain du brossage ne change pas avec la taille.
    const FRAG = `
      precision highp float;
      uniform sampler2D uMask;
      uniform vec2 uRes;
      uniform float uLight;   // abscisse du reflet, en pixels
      uniform float uTone;    // 1 acier, 0 aluminium clair
      uniform float uScale;   // densité de pixels
      varying vec2 vUv;

      float hash(vec2 p) { return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453); }
      float vnoise(vec2 p) {
        vec2 i = floor(p), f = fract(p);
        vec2 u = f * f * (3.0 - 2.0 * f);
        return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x),
                   mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
      }

      void main() {
        vec2 uv = vec2(vUv.x, 1.0 - vUv.y);
        float a = texture2D(uMask, uv).a;
        if (a < 0.003) { gl_FragColor = vec4(0.0); return; }

        vec2 px = uv * uRes / uScale; // pixels CSS
        // Stries : longues à l'horizontale, fines à la verticale, trois échelles.
        float s = vnoise(vec2(px.x / 140.0, px.y / 0.7)) * 0.5
                + vnoise(vec2(px.x / 45.0, px.y / 1.6)) * 0.3
                + hash(vec2(floor(px.y * 2.0), floor(px.x / 9.0))) * 0.2;

        // Biseau : gradient du masque, éclairé par le haut.
        vec2 t = 1.0 / uRes;
        float gx = texture2D(uMask, uv + vec2(t.x, 0.0)).a - texture2D(uMask, uv - vec2(t.x, 0.0)).a;
        float gy = texture2D(uMask, uv + vec2(0.0, t.y)).a - texture2D(uMask, uv - vec2(0.0, t.y)).a;
        float bevel = clamp(-gy * 0.9 - gx * 0.15, -1.0, 1.0);

        // Reflet anisotrope : bande verticale large + cœur plus serré, modulés par les stries.
        float d = (px.x - uLight / uScale);
        float wide = exp(-d * d / (2.0 * 140.0 * 140.0));
        float core = exp(-d * d / (2.0 * 28.0 * 28.0));
        float spec = (wide * 0.35 + core * 0.45) * (0.55 + 0.9 * s);

        // Lumière d'ambiance venue du haut.
        float top = 1.0 - uv.y * 0.35;

        vec3 alu   = vec3(0.70, 0.72, 0.74);
        vec3 steel = vec3(0.38, 0.40, 0.43);
        vec3 base = mix(alu, steel, uTone) * top;
        vec3 col = base * (0.86 + 0.24 * s) + spec * mix(vec3(0.32), vec3(0.42), uTone);
        col += bevel * mix(0.10, 0.16, uTone);
        col = clamp(col, 0.0, 1.0);
        gl_FragColor = vec4(col * a, a);
      }`;

    function compile(gl, type, src) {
      const sh = gl.createShader(type);
      gl.shaderSource(sh, src);
      gl.compileShader(sh);
      return gl.getShaderParameter(sh, gl.COMPILE_STATUS) ? sh : null;
    }

    function mount(el) {
      const canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      const gl = canvas.getContext('webgl', { premultipliedAlpha: true, antialias: false, alpha: true });
      if (!gl) return;
      const vs = compile(gl, gl.VERTEX_SHADER, VERT);
      const fs = compile(gl, gl.FRAGMENT_SHADER, FRAG);
      if (!vs || !fs) return;
      const prog = gl.createProgram();
      gl.attachShader(prog, vs);
      gl.attachShader(prog, fs);
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
      gl.useProgram(prog);

      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(prog, 'aPos');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

      const u = (n) => gl.getUniformLocation(prog, n);
      const uRes = u('uRes'), uLight = u('uLight'), uTone = u('uTone'), uScale = u('uScale');
      const tex = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);

      const mask = document.createElement('canvas');
      const state = { w: 0, h: 0, dpr: 1, light: 0, target: 0, tone: 1, toneTarget: 1, raf: 0, visible: true };

      // Masque : les lettres dessinées avec la police, la graisse et l'approche calculées du HTML,
      // posées sur la même ligne de base que le texte (interligne 1 : demi-approche répartie).
      function buildMask() {
        const cs = getComputedStyle(el);
        const size = parseFloat(cs.fontSize);
        const rect = el.getBoundingClientRect();
        if (!rect.width) return false;
        const padX = size * 0.15, padY = size * 0.3;
        const dpr = Math.min(Math.max(window.devicePixelRatio || 1, 2), 3); // au moins 2x : sur écran standard, le navigateur réduit et lisse les bords
        const w = Math.round((rect.width + padX * 2) * dpr);
        const h = Math.round((rect.height + padY * 2) * dpr);
        mask.width = canvas.width = w;
        mask.height = canvas.height = h;
        const ctx = mask.getContext('2d');
        ctx.clearRect(0, 0, w, h);
        ctx.scale(dpr, dpr);
        ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${size}px ${cs.fontFamily}`;
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = '#000';
        const m = ctx.measureText('H');
        const asc = m.fontBoundingBoxAscent ?? size * 0.83;
        const desc = m.fontBoundingBoxDescent ?? size * 0.3;
        const baseline = padY + (rect.height - (asc + desc)) / 2 + asc;
        const spacing = parseFloat(cs.letterSpacing) || 0;
        let x = padX;
        for (const ch of el.textContent.trim().toLocaleUpperCase('fr')) {
          ctx.fillText(ch, x, baseline);
          x += ctx.measureText(ch).width + spacing;
        }
        gl.bindTexture(gl.TEXTURE_2D, tex);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mask);
        Object.assign(state, { w, h, dpr });
        if (!state.light) state.light = state.target = w * 0.3;
        return true;
      }

      function readTone() {
        const v = parseFloat(getComputedStyle(el).getPropertyValue('--wordmark-tone'));
        return Number.isFinite(v) ? v : 1;
      }

      function draw() {
        gl.viewport(0, 0, state.w, state.h);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.uniform2f(uRes, state.w, state.h);
        gl.uniform1f(uLight, state.light);
        gl.uniform1f(uTone, state.tone);
        gl.uniform1f(uScale, state.dpr);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      }

      // Rendu à la demande : on interpole vers la cible puis on s'arrête.
      function tick() {
        state.raf = 0;
        const k = reduce ? 1 : 0.08;
        state.light += (state.target - state.light) * k;
        state.tone += (state.toneTarget - state.tone) * (reduce ? 1 : 0.12);
        draw();
        if (Math.abs(state.target - state.light) > 0.5 || Math.abs(state.toneTarget - state.tone) > 0.005) request();
      }
      function request() {
        if (!state.raf && state.visible) state.raf = requestAnimationFrame(tick);
      }

      if (!buildMask()) return;
      state.tone = state.toneTarget = readTone();
      el.append(canvas);
      draw();
      el.classList.add('is-gl');

      new ResizeObserver(() => {
        if (buildMask()) request();
      }).observe(el);
      new IntersectionObserver(([e]) => {
        state.visible = e.isIntersecting;
        if (state.visible) request();
      }).observe(el);

      if (!reduce) {
        if (finePointer) {
          // Le reflet suit la souris sur toute la page, rapportée à la largeur du logo.
          window.addEventListener('pointermove', (e) => {
            const r = canvas.getBoundingClientRect();
            const rel = (e.clientX - r.left) / r.width;
            state.target = Math.max(-0.2, Math.min(1.2, rel)) * state.w;
            request();
          }, { passive: true });
        }
      }
      window.addEventListener('scroll', () => {
        state.toneTarget = readTone(); // l'en-tête passe opaque après le hero
        if (!finePointer && !reduce) {
          const r = canvas.getBoundingClientRect();
          state.target = (0.3 + (r.top / window.innerHeight) * 0.6) * state.w;
        }
        request();
      }, { passive: true });
    }

    const start = () => document.fonts.ready.then(() => nodes.forEach(mount));
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 300);
  })();
  } catch(e) { console.error(e); }
})();

})();
